import { ReactNativeToWebEvent } from '@standardnotes/snjs';
export class MobileWebReceiver {
    constructor(application) {
        this.application = application;
        this.listeners = new Set();
        this.handleNativeMobileWindowMessage = (event) => {
            const nullOrigin = event.origin === '' || event.origin == null;
            if (!nullOrigin) {
                return;
            }
            const message = event.data;
            try {
                const parsed = JSON.parse(message);
                const { messageType, reactNativeEvent, messageData } = parsed;
                if (messageType === 'event' && reactNativeEvent) {
                    const nativeEvent = reactNativeEvent;
                    this.handleNativeEvent(nativeEvent, messageData);
                }
            }
            catch (error) {
                // eslint-disable-next-line no-console
                console.log('[MobileWebReceiver] Error parsing message from React Native', error);
            }
        };
        this.addReactListener = (listener) => {
            this.listeners.add(listener);
            return () => {
                this.listeners.delete(listener);
            };
        };
        this.listenForNativeMobileEvents();
    }
    deinit() {
        ;
        this.application = undefined;
        window.removeEventListener('message', this.handleNativeMobileWindowMessage);
        document.removeEventListener('message', this.handleNativeMobileWindowMessage);
    }
    listenForNativeMobileEvents() {
        const iOSEventRecipient = window;
        const androidEventRecipient = document;
        iOSEventRecipient.addEventListener('message', this.handleNativeMobileWindowMessage);
        androidEventRecipient.addEventListener('message', this.handleNativeMobileWindowMessage);
    }
    handleNativeEvent(event, messageData) {
        switch (event) {
            case ReactNativeToWebEvent.EnteringBackground:
                void this.application.handleMobileEnteringBackgroundEvent();
                break;
            case ReactNativeToWebEvent.GainingFocus:
                void this.application.handleMobileGainingFocusEvent();
                break;
            case ReactNativeToWebEvent.LosingFocus:
                void this.application.handleMobileLosingFocusEvent();
                break;
            case ReactNativeToWebEvent.ResumingFromBackground:
                void this.application.handleMobileResumingFromBackgroundEvent();
                break;
            case ReactNativeToWebEvent.AndroidBackButtonPressed:
                void this.application.handleAndroidBackButtonPressed();
                break;
            case ReactNativeToWebEvent.ColorSchemeChanged:
                void this.application.handleMobileColorSchemeChangeEvent();
                break;
            case ReactNativeToWebEvent.KeyboardSizeChanged:
                void this.application.handleMobileKeyboardWillChangeFrameEvent(messageData);
                break;
            case ReactNativeToWebEvent.KeyboardDidHide:
                void this.application.handleMobileKeyboardDidHideEvent();
                break;
            case ReactNativeToWebEvent.ReceivedFile:
                void this.application.handleReceivedFileEvent(messageData);
                break;
            case ReactNativeToWebEvent.ReceivedText:
                void this.application.handleReceivedTextEvent(messageData);
                break;
            case ReactNativeToWebEvent.ReceivedLink:
                void this.application.handleReceivedLinkEvent(messageData);
                break;
            case ReactNativeToWebEvent.OpenFilePreview:
                void this.application.handleOpenFilePreviewEvent(messageData);
                break;
            default:
                break;
        }
        this.listeners.forEach((listener) => listener(event));
    }
}
